import React from 'react';
import axios from 'axios';

import { default as config } from '../config';

const IconPicker = ({ onSelect = () => {}, visible = false }) => {
    const [icons, setIcons] = React.useState([]);

    React.useEffect(() => {
        let getIcons = async () => {
            try {
                let { data } = await axios.get(`${config.shop_url}/collections_icons.json`);
                setIcons(data);
            } catch {
                setIcons([]);
            }
        };
        getIcons();
    }, []);
    return (
        <div
            style={{
                display: visible ? 'grid' : 'none',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gridGap: '10px'
            }}
        >
            {icons.map((icn) => (
                <div key={icn}>
                    <a
                        href="#choose"
                        onClick={(e) => {
                            e.preventDefault();
                            onSelect(icn);
                        }}
                    >
                        <img src={`${config.shop_url}${icn}`} title={icn} alt={icn} style={{ width: '100px' }} />
                    </a>
                </div>
            ))}
        </div>
    );
};

export default IconPicker;
